import React from 'react';
import styled from 'styled-components';
import {COLORS, FONTS, SIZES} from '../styleVars';
import {Image, ImageProps} from '../image/Image';

const Chips = styled.div`
  display: flex;
  flex: 1 100%;
  flex-flow: wrap;
`;

const ChipWrapper = styled.span`
  display: flex;
  box-sizing: content-box;
  height: ${SIZES['32']};
  min-width: ${SIZES['72']};
  margin: ${SIZES['4']};
  cursor: pointer;
`;

interface DefaultChipProps {
  active: boolean;
}

const DefaultChip = styled.span<DefaultChipProps>`
  &&& {
    height: inherit;
    display: inline-flex;
    border-radius: ${SIZES['16']};
    min-width: ${SIZES['72']};
    transition: all 0.1s ease-in-out;
    background-color: ${(props) => (props.active ? COLORS.fupaSecondary : 'transparent')};
    border: ${(props) =>
      props.active ? `${SIZES['1']} solid ${COLORS.fupaSecondary}` : `${SIZES['1']} solid ${COLORS.lightGrey}`};
    color: ${(props) => (props.active ? COLORS.white : COLORS.black)};
  }
`;

const ChipLabel = styled.span`
  display: flex;
  line-height: ${SIZES['18']};
  font-size: ${FONTS['14']};
  padding: ${SIZES['8']} ${SIZES['12']};
  color: inherit;
`;

const ChipIconContainer = styled.div`
  margin: ${SIZES['1']} -${SIZES['6']} ${SIZES['1']} ${SIZES['1']};
  display: inline-flex;
  justify-content: center;
  height: ${SIZES['30']};
  width: ${SIZES['30']};
  background-color: ${COLORS.white};
  border-radius: 50%;
`;

const ChipImage = styled(Image)<ImageProps>`
  margin-right: -${SIZES['8']};
`;

interface ChipProps {
  /**
   * Defines if chip is selected
   */
  active: boolean;
  /**
   * The contents of the chip are passed as children
   */
  children: React.ReactNode;
  /**
   * Defines as which HTML-Element the Chip should be rendered
   */
  component?: string | React.ComponentClass<any, any> | React.FunctionComponent<any>;
  /**
   * Callback when Chip is clicked
   */
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  /**
   * @ignore
   */
  className?: string;
}

const Chip: React.FC<ChipProps> = ({active = false, children, component = 'span', onClick, className, ...props}) => {
  return (
    <ChipWrapper className={className}>
      <DefaultChip as={component} active={active} onClick={onClick} {...props}>
        {children}
      </DefaultChip>
    </ChipWrapper>
  );
};

export {Chips, Chip, ChipLabel, ChipIconContainer, ChipImage};
